import { useEffect, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Row, Col, Input, Button, Card, message, Typography } from 'antd';
import EndPoints from 'shared/endPoints/EndPoints.json';
import useHttpClient from 'shared/hooks/http-hook';
import Spinner from 'components/UIElements/Spiner/Spiner';
import { AuthContext } from 'shared/context/auth-context';
import MyModal from 'components/UIElements/MyModal';
import { buttonStyle } from 'shared/styles/baseStyle';
import TextArea from 'antd/lib/input/TextArea';

export default function InfoContract() {
  const { Title } = Typography;
  const formItemLayout = {
    labelCol: {
      span: 13
    },
    wrapperCol: {
      span: 18
    }
  };
  const [form] = Form.useForm();
  const {
    responseData,
    sendRequest,
    loading,
    status,
    responseMessage,
    requestIdentifier
  } = useHttpClient();
  const { id } = useParams();
  const { roleUser } = useContext(AuthContext);
  const acceptedRolesForActivateOrDeactivate = ['GT', 'AnyTimeAdmin'];
  const [isModalVisiblePassword, setIsModalVisiblePassword] = useState(false);
  const [isModalVisiblePushNotification, setIsModalVisiblePushNotification] =
    useState(false);

  useEffect(() => {
    sendRequest({
      endpoint: `${EndPoints.CONTRACT.GETCONTRACT}/${id}`,
      method: 'GET'
    });
  }, [sendRequest, id, responseData?.hasActiveUserAccount]);

  useEffect(() => {
    form.setFieldsValue({
      firstName: responseData?.firstName,
      lastName: responseData?.lastName,
      policyNumber: responseData?.policyNumber,
      plateNumber: responseData?.plateNumber,
      carMarque: responseData?.carMarque,
      mobilePhone: responseData?.mobilePhone,
      email: responseData?.email,
      startDate: responseData?.startDate,
      endDate: responseData?.endDate,
      imei: responseData?.imei,
      carModel: responseData?.carModel,
      currentPackageDuration: responseData?.currentPackageDuration,
      isActive: responseData?.isActive,
      kilometers: responseData?.kilometers,
      deviceStatusMode: responseData?.deviceStatusMode,
      deviceStatusObd: responseData?.deviceStatusObd,
      deviceStatusSleep: responseData?.deviceStatusSleep,
      initialPackageDuration: responseData?.initialPackageDuration,
      duration: responseData?.duration,
      dateCreated: responseData?.dateCreated,
      deviceType: responseData?.deviceType,
      heartbeatDate: responseData?.heartbeatDate,
      heartbeatValue: responseData?.heartbeatValue ? 'Ενεργή' : 'Ανενεργή',
      channel: responseData?.channel,
      batteryVoltage: responseData?.batteryVoltage
    });
  }, [responseData, form]);

  const handleClick = () => {
    setIsModalVisiblePassword(true);
  };

  const handleClickModalForPushNotification = () => {
    setIsModalVisiblePushNotification(true);
  };

  const handleModalYes = () => {
    setIsModalVisiblePassword(false);
    const userUrl = responseData?.hasActiveUserAccount
      ? EndPoints.USERACCOUNT.DEACTIVATEUSER
      : EndPoints.USERACCOUNT.ACTIVATEUSER;

    sendRequest({
      endpoint: userUrl,
      method: 'PUT',
      data: { userId: responseData.userId }
    });
  };

  const handleModalForPushNotificationYes = () => {
    const regex = /^https:\/\/.+/i;
    const title = form.getFieldValue('title');
    const body = form.getFieldValue('body');
    const url =
      form.getFieldValue('url') === '' ? null : form.getFieldValue('url');

    if (url && !regex.test(url)) {
      message.error('Πρέπει να είναι κενό ή URL που ξεκινάει με https://');
      return;
    }
    sendRequest(
      {
        endpoint: `${EndPoints.PUSHNOTIFICATION.PUSHNOTIFICATION}/${responseData.contractId}`,
        method: 'POST',
        data: { contractId: responseData.contractId, title, body, url }
      },
      `SENDPUSHNOTIFICATION`
    );
  };

  const handleModalNo = () => {
    setIsModalVisiblePassword(false);
  };

  const handleModalForPushNotificationNo = () => {
    setIsModalVisiblePushNotification(false);
    form.resetFields(['title', 'body', 'url']);
  };

  const sendUsernameByEmail = () => {
    sendRequest(
      {
        endpoint: `${EndPoints.USERACCOUNT.SENDUSERNAME}?UserId=${responseData?.userId}&SendType=2`,
        method: 'GET'
      },
      `SENDUSERNAMEBYEMAIL`
    );
  };

  const sendPolicyNumberByEmail = () => {
    sendRequest(
      {
        endpoint: `${EndPoints.CONTRACT.SENDPOLICYNUMBER}?UserId=${responseData?.userId}`,
        method: 'GET'
      },
      `SENDPOLICYNUMBERBYEMAIL`
    );
  };

  const sendUsernameBySms = () => {
    sendRequest(
      {
        endpoint: `${EndPoints.USERACCOUNT.SENDUSERNAME}?UserId=${responseData?.userId}&SendType=1`,
        method: 'GET'
      },
      `SENDUSERNAMEBYSMS`
    );
  };

  const getSentMessage = apiRequest => {
    if (apiRequest === 'SENDPOLICYNUMBERBYEMAIL') {
      return 'Η αποστολή Αριθμού Συμβολαίου με E-mail πραγματοποιήθηκε με επιτυχία';
    }
    let sendType = 'SMS';
    if (apiRequest === `SENDUSERNAMEBYEMAIL`) {
      sendType = 'E-mail';
    }
    return `Η αποστολή Username με ${sendType} πραγματοποιήθηκε με επιτυχία`;
  };

  useEffect(() => {
    if (requestIdentifier === 'SENDPUSHNOTIFICATION' && status === 'resolved') {
      message.success(
        'Η αποστολή της ειδοποίησης πραγματοποιήθηκε με επιτυχία'
      );
      form.resetFields(['title', 'body', 'url']);
      setIsModalVisiblePushNotification(false);
      return;
    }
    if (requestIdentifier === 'SENDPUSHNOTIFICATION' && status === 'rejected') {
      message.error('Η αποστολή της ειδοποίησης απέτυχε');
      return;
    }

    if (
      requestIdentifier !== 'SENDUSERNAMEBYEMAIL' &&
      requestIdentifier !== 'SENDUSERNAMEBYSMS' &&
      requestIdentifier !== 'SENDPOLICYNUMBERBYEMAIL'
    ) {
      return;
    }

    const sentMessage = getSentMessage(requestIdentifier);
    if (status === 'pending') {
      message.loading();
    }
    if (status === 'resolved') {
      message.success(sentMessage);
    }
  }, [status, responseData, responseMessage, requestIdentifier]);

  const modalMessage = responseData?.hasActiveUserAccount
    ? ' Επιθυμείτε να γίνει απενεργοποίηση των κωδικών του χρήστη;'
    : 'Επιθυμείτε να γίνει ενεργοποίηση των κωδικών του χρήστη;';

  if (loading) return <Spinner />;
  return (
    <>
      <Form {...formItemLayout} form={form}>
        {responseData?.isGdprDeleted === 'Ναι' && (
          <Row align="center">
            <Col>
              <Title type="danger" underline level={4}>
                Διεγραμμένος Λογαριασμός
              </Title>
            </Col>
          </Row>
        )}
        <Row>
          <Col span={8}>
            <Form.Item label="Επώνυμο" name="lastName">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Όνομα" name="firstName">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Κινητό" name="mobilePhone">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Αρ. Συμβολαίου" name="policyNumber">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Κατάσταση" name="isActive">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Αρ. Κυκλοφορίας" name="plateNumber">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Μάρκα" name="carMarque">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Ημερομηνία Έναρξης" name="startDate">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Ημερομηνία Λήξης" name="endDate">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Μοντέλο" name="carModel">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Αρχικό Πακέτο" name="initialPackageDuration">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Χιλιόμετρα Πακέτου "
              name="currentPackageDuration"
            >
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Καταναλωθέντα Χιλιόμετρα" name="kilometers">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Κατάσταση Συσκευής" name="deviceStatusObd">
              <Input readOnly />
            </Form.Item>
          </Col>
          {roleUser === 'GT' && (
            <>
              {form.getFieldValue('deviceType') === 'OBD' && (
                <Col span={8}>
                  <Form.Item label="OBD Mode" name="deviceStatusMode">
                    <Input readOnly />
                  </Form.Item>
                </Col>
              )}
              <Col span={8}>
                <Form.Item
                  label=" Κατάσταση Ύπνου Συσκευής "
                  name="deviceStatusSleep"
                >
                  <Input readOnly />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Ημ/νία Δημιουργίας" name="dateCreated">
                  <Input readOnly />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="DeviceType" name="deviceType">
                  <Input readOnly />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>
        <Row>
          <Col span={12} pull={4}>
            <Form.Item label="Email" name="email">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col span={7} pull={3}>
            <Form.Item label="IMEI Συσκευής" name="imei">
              <Input readOnly />
            </Form.Item>
          </Col>
          {responseData?.deviceType !== 'OBD' && roleUser !== 'AnyTime' && (
            <Col span={5}>
              <Form.Item
                label="Eπίπεδο Μπαταρίας"
                name="batteryVoltage"
                labelCol={{ offset: 2 }}
              >
                <Input readOnly />
              </Form.Item>
            </Col>
          )}
        </Row>
        {roleUser === 'GT' && (
          <Row>
            <Col span={12} pull={4}>
              <Form.Item label="Τελευταίο heartbeat" name="heartbeatDate">
                <Input readOnly />
              </Form.Item>
            </Col>
            {form.getFieldValue('deviceType') !== 'OBD' && (
              <Col span={12} pull={7}>
                <Form.Item label="Κατάσταση εφαρμογής" name="heartbeatValue">
                  <Input readOnly />
                </Form.Item>
              </Col>
            )}
          </Row>
        )}
        <Col span={12} pull={4}>
          <Form.Item label="Channel" name="channel">
            <Input readOnly />
          </Form.Item>
        </Col>
      </Form>
      <Card>
        {acceptedRolesForActivateOrDeactivate.includes(roleUser) && (
          <>
            <Button style={buttonStyle} onClick={handleClick}>
              {responseData?.hasActiveUserAccount
                ? 'Απενεργοποίηση Κωδικών'
                : 'Ενεργοποίηση Κωδικών'}
            </Button>
            <MyModal
              message={modalMessage}
              title="Ενεργοποίηση/Απενεργοποίηση Κωδικών Χρήστη"
              visible={isModalVisiblePassword}
              onOk={handleModalYes}
              onCancel={handleModalNo}
            />
          </>
        )}
        <Button style={buttonStyle} onClick={() => sendUsernameByEmail()}>
          Αποστολή Username με Email
        </Button>
        <Button style={buttonStyle} onClick={() => sendPolicyNumberByEmail()}>
          Αποστολή Αριθμού ΣΛ με Email
        </Button>

        {roleUser === 'GT' && (
          <>
            <Button style={buttonStyle} onClick={() => sendUsernameBySms()}>
              Αποστολή Username με SMS
            </Button>{' '}
            <Button
              style={buttonStyle}
              onClick={() =>
                window.open(
                  `https://myshortdrive.gr/impersonateClient/?userId=${responseData?.userId}`
                )
              }
            >
              Προσομοίωση Χρήστη
            </Button>
          </>
        )}
        {roleUser === 'GT' && (
          <>
            <Button
              onClick={handleClickModalForPushNotification}
              style={buttonStyle}
            >
              Δοκιμή Αποστολής Push
            </Button>
            <MyModal
              title="Δοκιμή Αποστολής Push"
              message={
                <Form form={form}>
                  <Col span={24}>
                    <Form.Item name="title">
                      <Input placeholder="Τίτλος" />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item name="body">
                      <TextArea rows={20} placeholder="Μήνυμα" />
                    </Form.Item>
                    <Form.Item name="url">
                      <TextArea rows={2} placeholder="url" />
                    </Form.Item>
                  </Col>
                </Form>
              }
              visible={isModalVisiblePushNotification}
              onOk={handleModalForPushNotificationYes}
              onCancel={handleModalForPushNotificationNo}
            />
          </>
        )}
      </Card>
    </>
  );
}
